// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"722":"c88d39f9","1470":"c88d39f9","1545":"0f901063","3613":"0f901063","4572":"c88d39f9","4597":"0f901063","5478":"0f901063","6152":"c88d39f9","6381":"c88d39f9"}[chunkId] + ".chunk.css";
};